<script>
  import { procedurePriceList } from '../../../../../store/common';

  console.log('$procedurePriceList', $procedurePriceList);
</script>

<div class="uk-modal-body">
  <h2 class="uk-modal-title">Thank You!</h2>

  <p class="uk-text-small">
    Lorem ipsum dolor sit amet, consectetur adipisicing elit. A adipisci at aut
    consequuntur debitis dolor ducimus eaque earum eum explicabo facilis, iure
    maxime mollitia odit rem similique, temporibus voluptate voluptatem.
  </p>

  <div
    class="uk-flex-between uk-flex uk-margin-small-bottom text-xsmall uk-text-uppercase uk-text-muted"
  >
    <span>Procedure</span>
    <span>Rates</span>
  </div>

  <ul class="uk-list uk-list-striped uk-margin-remove-top uk-text-small">
    {#each $procedurePriceList.procedures as item}
      <li class="uk-flex uk-flex-between" style="padding: 8px">
        <span class="text-ellipsis uk-margin-small-right">{item.name}</span>

        <strong class="uk-text-secondary uk-text-nowrap">
          ${item.from} - ${item.to}
        </strong>
      </li>
    {/each}
  </ul>

  <hr />

  <p class="uk-flex uk-flex-right uk-flex-bottom" style="padding-right: 8px">
    <span class="uk-text-small uk-margin-small-right">
      Total Estimate (from)
    </span>

    <strong class="uk-text-secondary"
      >${$procedurePriceList.min_total_price} - ${$procedurePriceList.max_total_price}</strong
    >
  </p>
</div>
